import http from "../../services/http";

export const getAllFilesByLabelRequest = (data) => {
  return http.get("files", data);
};

export const getFileByPathAndToken = (path, token) => {
  return http.get(`files/${path}?token=${token}`, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
